var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Api } from '@app/Api';
import { Grid } from '@app/Components/Grid/Grid';
import { Column, Sorting, FilterRow, Scrolling } from 'devextreme-react/data-grid';
import { ApprovalTaskTypeEnum } from '@app/AppConstants';
import { FunctionCell } from './FunctionCell';
import styles from '../Deliverable.module.scss';
var DeliverableApprovalGrid = /** @class */ (function (_super) {
    __extends(DeliverableApprovalGrid, _super);
    function DeliverableApprovalGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeliverableApprovalGrid.prototype._renderCell = function (data, period) {
        var _a = this.props, functions = _a.functions, onSave = _a.onSave;
        return (React.createElement(FunctionCell, { cellInfo: {
                itemId: data.id,
                templateFunctionRange: data.deliverableTemplateFunctionsRange,
                period: period,
                functions: functions,
                type: ApprovalTaskTypeEnum.Deliverable,
                timeUnit: this.props.approvalTimeUnit
            }, onSave: onSave, create: function (body) {
                return Api.secured.createDeliverableTemplateFunctionsRange({ body: body });
            }, update: function (body) {
                return Api.secured.updateDeliverableTemplateFunctionsRange({ body: body });
            }, delete: function (id) { return Api.secured.deleteDeliverableTemplateFunctionsRange({ body: [id] }); } }));
    };
    DeliverableApprovalGrid.prototype.render = function () {
        var _this = this;
        var _a = this.props, dataSource = _a.dataSource, approvalTimeUnit = _a.approvalTimeUnit;
        var unitSuffix = approvalTimeUnit === 'Week' ? 'w' : 'd';
        var multiplier = approvalTimeUnit === 'Week' ? 1 : 7;
        var min = -13 * multiplier;
        var gatePreparationPeriod = -2 * multiplier;
        var periods = Array.from({ length: -min + 1 }, function (_, i) { return min + i; });
        return (React.createElement(Grid, { dataSource: dataSource, rowAlternationEnabled: true, height: "calc(100vh - 250px)" },
            React.createElement(Scrolling, { showScrollbar: "always", useNative: false, mode: "standard" }),
            React.createElement(Sorting, { mode: "multiple" }),
            React.createElement(FilterRow, { visible: true }),
            React.createElement(Column, { caption: "Gate", dataField: "gateTemplateDisplayName", width: 70 }),
            React.createElement(Column, { caption: "Function", dataField: "functionCode", width: 70 }),
            React.createElement(Column, { caption: "ID", dataField: "code", width: 120 }),
            React.createElement(Column, { caption: "Deliverable name", dataField: "deliverableName", width: 250 }),
            periods.map(function (period) { return (React.createElement(Column, { key: period, caption: period === 0 ? '0' : "".concat(period).concat(unitSuffix), cssClass: period <= gatePreparationPeriod && period > gatePreparationPeriod - multiplier
                    ? "".concat(styles.gridColumn, " ").concat(styles.gatePreparationColumn)
                    : period <= 0 && period > -multiplier
                        ? "".concat(styles.gridColumn, " ").concat(styles.gateMeetingColumn)
                        : styles.gridColumn, minWidth: 50, cellRender: function (_a) {
                    var data = _a.data;
                    return _this._renderCell(data, period);
                } })); })));
    };
    return DeliverableApprovalGrid;
}(React.PureComponent));
export { DeliverableApprovalGrid };
